import React, { Component } from 'react'
import Barrio from '../Neighborhood.component'
import { Link } from 'react-router'
import { Col } from 'react-bootstrap'

export default class Barrios extends Component {

  UNSAFE_componentWillMount() {
    window.scrollTo(0, 0)
    this.props.loadNeighbors()
  }

  render () {

    const { visibleNeighborhoods } = this.props

    return (
      <div className='container'>
        {(visibleNeighborhoods.length > 0) ? (
          visibleNeighborhoods.map((item, index) =>
            <Col xs={12} md={4} sm={6} className='col-neighborhood' key={index}>
              <Link key={index} to={'barrios/' + item.id } >
                <Barrio title={item.name} img={item.images} id={item.id} />
              </Link>
            </Col>
          )) : ''
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/PageResidential/components/Neighborhoods/Neighborhoods.component.js